import Card from 'components/Card/Card.jsx';
import moment from 'moment';
import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { Col, Grid, Row, Badge, Navbar, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Bar } from 'react-chartjs-2';
import Select from 'react-select';
import numeral from 'numeral';
import axios from 'axios';

import Loading from '../../components/Loading';
import logo from '../../assets/img/Icono.png';
//Redux
import { bindActionCreators } from 'redux';
import Feathers from '../../feathers.js';
import * as FranchiseReportsActions from './redux/FranchiseReportsActions';

moment.globalLocale = 'es';

class FranchiseReportsIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        franchiseId: '',
      },
      formDataOperators: {
        date_initial: moment().startOf('month').format('YYYY-MM-DD'),
        date_final: moment().endOf('month').format('YYYY-MM-DD'),
      },
      dataChartOperators: {
        datasets: [
          {
            label: 'Resumen',
            data: [],
          },
        ],
        labels: [],
      },
      dataChartQuotationJS: {
        datasets: [
          {
            label: 'Resumen',
            data: [],
          },
        ],
        labels: [],
      },
      dataChartHotels: {
        datasets: [
          {
            label: 'Resumen',
            data: [],
          },
        ],
        labels: [],
      },
      data: [],
      franchises: [],
      dataOperators: [],
      dataHotels: [],
      report: {},
      totalQuotations: 0,
      totalSales: 0,
      totalAccess: 0,
      totalSalesPrice: 0,
      totalSalesBuyPrice: 0,
      totalOperatorsCount: 0,
      totalOperatorsPrice: 0,
      totalHotelsPrice: 0,
      totalHotelsCount: 0,
      finished: true,
      franchiseDateSelected: true,
    };
  }

  async componentWillMount() {
    var franchises = await Feathers.service('franchises').find({
      query: {
        $limit: 1000,
      },
    });

    franchises = franchises.data
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((franchise) => {
        return {
          value: franchise._id,
          label: franchise.name,
        };
      });

    franchises.unshift({ value: null, label: '--TODAS--' });

    this.setState({
      franchises: franchises,
    });
  }

  search(event) {
    let search = event.target.value;
    this.props.searchTable(search);
  }

  generateFranchiseReport = async () => {
    this.setState({ finished: false });

    let franchiseId = this.state.formData.franchiseId.value;

    var generalReports = await Feathers.service('general-reports').get(
      franchiseId,
      {
        query: {
          dates: {
            dateInitial: moment(
              this.state.formDataOperators.date_initial,
            ).startOf('day'),
            dateFinal: moment(this.state.formDataOperators.date_final).endOf(
              'day',
            ),
          },
        },
      },
    );

    var dataChartQuotationJS = {};
    let quotationArray = [];

    quotationArray = generalReports.quotations;
    if (quotationArray.length === 0) {
      this.setState({
        loading: false,
        titleLoading: 'No se encontraron registros',
      });
    } else {
      var quotationStatusLabel = [
        'Prospectos',
        'Enviadas',
        'Garantizadas',
        'Logradas',
        'Caídas',
      ];
      var quotationStatusArray = [0, 0, 0, 0, 0];

      quotationArray.map(function (item, key) {
        switch (item.status) {
          case 'achieved':
            quotationStatusArray[3]++;
            break;
          case 'down':
            quotationStatusArray[4]++;
            break;
          case 'guaranteed':
            quotationStatusArray[2]++;
            break;
          case 'leats':
            quotationStatusArray[0]++;
            break;
          case 'sended':
            quotationStatusArray[1]++;
            break;
          default:
            break;
        }
      });
    }

    dataChartQuotationJS = {
      datasets: [
        {
          label: 'Cantidad',
          data: quotationStatusArray,
          backgroundColor: [
            'rgb(194, 56, 35,0.5)',
            'rgb(241, 196, 14,0.5)',
            'rgb(230, 126, 33,0.5)',
            'rgb(94, 185, 37,0.5)',
            'rgb(129, 190, 247,0.5)',
          ],
        },
      ],
      labels: quotationStatusLabel,
    };

    let resultReport = await this.generateReportOperators(franchiseId);
    this.setState({
      report: generalReports,
      totalAccess: generalReports.totalAccess,
      totalQuotations: generalReports.quotations.length,
      totalSales: generalReports.totalSalesCount,
      totalSalesPrice: generalReports.totalSales,
      totalSalesBuyPrice: generalReports.totalSalesBuyPrice,
      dataChartQuotationJS: dataChartQuotationJS,

      dataChartOperators: resultReport.dataChartOperators,
      dataOperators: resultReport.dataOperators,
      totalOperatorsCount: resultReport.totalOperatorsCount,
      totalOperatorsPrice: resultReport.totalOperatorsPrice,

      dataHotels: resultReport.dataHotels,
      dataChartHotels: resultReport.dataChartHotels,
      totalHotelsCount: resultReport.totalHotelsCount,
      totalHotelsPrice: resultReport.totalHotelsPrice,
      loading: resultReport.loading,
      finished: true,
    });
  };

  onChange = async (path, value) => {
    var newFormData;
    if (value) {
      newFormData = immutable.set(this.state.formData, path, value);
      this.setState({
        franchiseDateSelected: false,
        formData: newFormData,
      });
    } else {
      newFormData = immutable.set(this.state.formData, path, '');
      this.setState({
        formData: newFormData,
        franchiseDateSelected: true,
      });
    }
  };

  onChangeDate = (path, value) => {
    var newFormData;
    if (value) {
      newFormData = immutable.set(this.state.formDataOperators, path, value);
      this.setState({
        formDataOperators: newFormData,
        franchiseDateSelected: false,
      });
    } else {
      newFormData = immutable.set(this.state.formDataOperators, path, value);
      this.setState({
        formDataOperators: newFormData,
        franchiseDateSelected: true,
      });
    }
  };

  generateReportOperators = async (id) => {
    var _this = this;
    const {
      formDataOperators: { date_initial, date_final },
    } = this.state;

    return new Promise(async (resolve, reject) => {
      let totalOperatorsCount = 0;
      let totalOperatorsPrice = 0;
      let totalOperatorsPublicPrice = 0;
      let totalHotelsPrice = 0;
      let totalHotelsCount = 0;

      var urlHotels = `${process.env.REACT_APP_URL_FEATHERS}/report-hotels?dateInit=${date_initial}&dataEnd=${date_final}`;
      var url = `${process.env.REACT_APP_URL_FEATHERS}/report-operators?dateInit=${date_initial}&dataEnd=${date_final}`;

      if (id) {
        const franchiseIdParam = `&franchiseId=${id}`;
        urlHotels += franchiseIdParam;
        url += franchiseIdParam;
      }

      _this.setState({ loading: false });
      var resultJson = [];
      var dataCharJS = {};
      var resultJsonHotels = [];
      var dataCharHotelsJS = {};
      await axios
        .get(url)
        .then(function (result) {
          resultJson = result.data;
          if (resultJson.length === 0) {
            _this.setState({
              loading: false,
              titleLoading: 'No se encontraron registros',
            });
          } else {
            var itemHotelLabel = [];
            var itemHotelTotal = [];
            resultJson.map(function (item, key) {
              if (key < 10) {
                itemHotelLabel.push(item.name);
                itemHotelTotal.push(item.total);
              }
            });

            dataCharJS = {
              datasets: [
                {
                  label: 'Cantidad',
                  data: itemHotelTotal,
                  backgroundColor: [
                    'rgb(73,114,177,69)',
                    'rgb(72,156,199,78)',
                    'rgb(68,180,189,74)',
                    'rgb(147,176,55,69)',
                    'rgb(84,99,36,39)',
                    'rgb(176,90,141,69)',
                    'rgb(227,135,70,89)',
                    'rgb(104,163,252,99)',
                    'rgb(46,72,112,44)',
                    'rgb(176,135,55,69)',
                  ],
                },
              ],
              labels: itemHotelLabel,
            };
          }
        })
        .catch(function (err) {
          _this.setState({
            loading: false,
            titleLoading: 'Error al consultar información',
          });
        });

      await axios
        .get(urlHotels)
        .then(function (result) {
          resultJsonHotels = result.data;
          if (resultJsonHotels.length === 0) {
            _this.setState({
              loading: false,
              titleLoading: 'No se encontraron registros',
            });
          } else {
            var itemHotelLabel = [];
            var itemHotelTotal = [];
            resultJsonHotels.map(function (item, key) {
              if (key < 10) {
                itemHotelLabel.push(item.name.substring(0, 14));
                itemHotelTotal.push(item.total);
              }
            });

            dataCharHotelsJS = {
              datasets: [
                {
                  label: 'Cantidad',
                  data: itemHotelTotal,
                  backgroundColor: [
                    'rgb(179, 209, 252,99)',
                    'rgb(93,81,176, 69)',
                    'rgb(63,168,176,69)',
                    'rgb(73,114,177,69)',
                    'rgb(176,90,141,69)',
                    'rgb(176,135,55,69)',
                    'rgb(71,176,63,69)',
                    'rgb(176,100,90,69)',
                    'rgb(252,180,129,99)',
                    'rgb(227,135,70,89)',
                  ],
                },
              ],
              labels: itemHotelLabel,
            };
          }
        })
        .catch(function (err) {
          console.log(err);
          _this.setState({
            loading: false,
            titleLoading: 'Error al consultar información',
          });
        });

      for (var operator of resultJson) {
        totalOperatorsCount += operator.count;
        totalOperatorsPrice += operator.total;
        totalOperatorsPublicPrice += operator.publicPrice;
      }

      for (var hotel of resultJsonHotels) {
        totalHotelsCount += hotel.count;
        totalHotelsPrice += hotel.total;
      }

      let objectResult = {
        dataOperators: resultJson,
        dataChartOperators: dataCharJS,
        dataHotels: resultJsonHotels,
        dataChartHotels: dataCharHotelsJS,
        loading: true,
        totalOperatorsCount: totalOperatorsCount,
        totalOperatorsPrice: totalOperatorsPrice,
        totalHotelsCount: totalHotelsCount,
        totalHotelsPrice: totalHotelsPrice,
      };
      return resolve(objectResult);
    });
  };

  translateStatus(status) {
    switch (status) {
      case 'leats':
        return <Badge style={{ background: '#c23823' }}> "Prospecto" </Badge>;
      case 'sended':
        return (
          <Badge style={{ background: '#f1c40e', color: '#565454' }}>
            {' '}
            "Enviado"{' '}
          </Badge>
        );
      case 'guaranteed':
        return <Badge style={{ background: '#e67e21' }}> "Garantizado" </Badge>;
      case 'achieved':
        return <Badge style={{ background: '#5eb925' }}> "Logrado" </Badge>;
      case 'down':
        return <Badge style={{ background: '#81bef7' }}> "Caída" </Badge>;

      default:
        return <Badge> "Sin estatus" </Badge>;
    }
  }

  render() {
    let _this = this;
    let {
      franchises,
      formData,
      franchiseDateSelected,
      formDataOperators,
      dataHotels,
      finished,
      dataOperators,
    } = this.state;

    const franchiseId = formData.franchiseId.value;
    const initDate = formDataOperators.date_initial;
    const endDate = formDataOperators.date_final;

    const excelReportsURL = `${
      process.env.REACT_APP_URL_FEATHERS
    }/franchises-sales-excel-report/?startDate=${initDate}&endDate=${endDate}${
      franchiseId ? `&franchiseId=${franchiseId}` : ''
    }`;

    return (
      <div className="main-content">
        {finished !== true ? (
          <Loading />
        ) : (
          <Grid fluid>
            <Row>
              <Col md={12}>
                <Card
                  title={
                    <div>
                      {'Reportes por Franquicia'}{' '}
                      <div className="pull-right header-table">
                        <Navbar.Form className="navbar-search-form">
                          <div className="pull-left header-table">
                            <label style={{ fontWeight: '250' }}>Desde :</label>
                            <input
                              id="date"
                              style={{ color: '#000000' }}
                              type="date"
                              className="form-control"
                              value={formDataOperators.date_initial}
                              onChange={(event) =>
                                this.onChangeDate(
                                  'date_initial',
                                  event.target.value,
                                )
                              }
                              name="date"
                            />
                            <label style={{ fontWeight: '250' }}>Hasta :</label>
                            <input
                              id="date"
                              style={{ color: '#000000' }}
                              type="date"
                              className="form-control"
                              value={formDataOperators.date_final}
                              onChange={(event) =>
                                _this.onChangeDate(
                                  'date_final',
                                  event.target.value,
                                )
                              }
                              name="date"
                            />
                          </div>
                        </Navbar.Form>
                      </div>
                    </div>
                  }
                  content={
                    <Row>
                      <Col md={12}>
                        <div
                          className="pull-right header-table"
                          style={{ paddingRight: 30 }}
                        >
                          <div
                            className="pull-right header-table"
                            style={{ padding: 10 }}
                          >
                            <Button
                              disabled={franchiseDateSelected}
                              href={excelReportsURL}
                              style={{
                                backgroundColor: '#69a900',
                                border: '#69a900',
                                color: '#fff',
                                fontWeight: '500',
                                width: '200px',
                              }}
                            >
                              Descargar reporte
                            </Button>
                          </div>
                          <div
                            className="pull-right header-table"
                            style={{ padding: 10 }}
                          >
                            <Button
                              disabled={franchiseDateSelected}
                              onClick={_this.generateFranchiseReport}
                              style={{
                                backgroundColor: '#69a900',
                                border: '#69a900',
                                color: '#fff',
                                fontWeight: '500',
                                width: '200px',
                              }}
                            >
                              Generar
                            </Button>
                          </div>
                          <div
                            className="pull-right header-table"
                            style={{ padding: 10 }}
                          >
                            <Select
                              style={{ width: 250, fontSize: 18 }}
                              wrapperStyle={{
                                width: 250,
                                zIndex: 5,
                              }}
                              menuStyle={{ width: 250, fontSize: 18 }}
                              placeholder="-- Seleccionar franquicia --"
                              name="franchise"
                              value={formData.franchiseId}
                              options={franchises}
                              onChange={(franchise) =>
                                this.onChange('franchiseId', franchise)
                              }
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col lg={6} sm={12}>
                <div className="cardstyle">
                  <p style={{ fontWeight: '600' }}>Ingresos por Ventas:</p>
                  <p style={{ fontSize: '32px' }}>
                    {numeral(this.state.totalSalesPrice).format('$0,0.00')}
                  </p>
                  <p
                    style={{
                      fontSize: '15px',
                      textAlign: 'left',
                      fontWeight: '600',
                    }}
                  >
                    {'Cantidad total de Ventas: ' + this.state.totalSales}
                  </p>
                </div>
              </Col>
              <Col lg={6} sm={12}>
                <div className="cardstyle2">
                  <p style={{ fontWeight: '600' }}>Accesos:</p>
                  <p style={{ fontSize: '32px' }}>{this.state.totalAccess}</p>
                  <p
                    style={{
                      fontSize: '15px',
                      textAlign: 'left',
                      fontWeight: '600',
                    }}
                  >
                    {'Total de Accesos '}
                  </p>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6} sm={12}>
                <div className="cardstyle2">
                  <p style={{ fontWeight: '600' }}>Ventas de Operadores:</p>
                  <p style={{ fontSize: '32px' }}>
                    {numeral(this.state.totalOperatorsPrice).format('$0,0.00')}
                  </p>
                  <p
                    style={{
                      fontSize: '15px',
                      textAlign: 'left',
                      fontWeight: '600',
                    }}
                  >
                    {'Ventas Globales de Operadores: ' +
                      this.state.totalOperatorsCount}
                  </p>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Card
                  title={
                    <div>
                      {'Reporte de Estatus de Cotizaciones '}
                      <div className="pull-right header-table" />
                    </div>
                  }
                  ctFullWidth
                  content={
                    <div>
                      {this.state.loading ? (
                        <Bar
                          loading={_this.state.loading}
                          ref="chart"
                          height={80}
                          redraw={true}
                          data={_this.state.dataChartQuotationJS}
                        />
                      ) : (
                        <h4
                          style={{
                            textAlign: 'center',
                            marginTop: '85px',
                            marginBottom: '85px',
                          }}
                        >
                          {this.state.titleLoading}
                        </h4>
                      )}
                    </div>
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Card
                  title={
                    <div>
                      {'Reporte de Operadores '}
                      <div className="pull-right header-table" />
                    </div>
                  }
                  ctFullWidth
                  content={
                    <div>
                      {this.state.loading ? (
                        <Bar
                          loading={_this.state.loading}
                          ref="chart"
                          height={80}
                          redraw={true}
                          data={_this.state.dataChartOperators}
                        />
                      ) : (
                        <h4
                          style={{
                            textAlign: 'center',
                            marginTop: '85px',
                            marginBottom: '85px',
                          }}
                        >
                          {this.state.titleLoading}
                        </h4>
                      )}
                    </div>
                  }
                />
                {this.state.loading ? (
                  <div style={{ marginBottom: '30px' }}>
                    <img
                      src={logo}
                      style={{ height: '40px', marginBottom: '10px' }}
                      alt=""
                    ></img>
                    <span
                      style={{
                        fontSize: '20px',
                        color: '#000',
                        fontWeight: '100',
                      }}
                    >
                      Operadores
                    </span>
                    <div className="containerTable">
                      <table>
                        <thead>
                          <tr>
                            <th>Operador</th>
                            <th width={150}>Cantidad</th>
                            <th width={150}>Costo</th>
                            <th width={150}>Tarifa Pública</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataOperators.map(function (item, key) {
                            return (
                              <tr key={key}>
                                <td>{item.name}</td>
                                <td align="center">{item.count}</td>
                                <td align="center">
                                  {numeral(item.total).format('$0,00.00')}
                                </td>
                                <td align="center">
                                  {numeral(item.publicPrice).format('$0,00.00')}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : null}
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Card
                  title={
                    <div>
                      {'Reporte de Hoteles '}
                      <div className="pull-right header-table" />
                    </div>
                  }
                  ctFullWidth
                  content={
                    <div>
                      {this.state.loading ? (
                        <Bar
                          loading={_this.state.loading}
                          ref="chart"
                          height={80}
                          redraw={true}
                          data={_this.state.dataChartHotels}
                        />
                      ) : (
                        <h4
                          style={{
                            textAlign: 'center',
                            marginTop: '85px',
                            marginBottom: '85px',
                          }}
                        >
                          {this.state.titleLoading}
                        </h4>
                      )}
                    </div>
                  }
                />
                {this.state.loading ? (
                  <div style={{ marginBottom: '30px' }}>
                    <img
                      src={logo}
                      style={{ height: '40px', marginBottom: '10px' }}
                      alt="logo"
                    ></img>
                    <span
                      style={{
                        fontSize: '20px',
                        color: '#000',
                        fontWeight: '100',
                      }}
                    >
                      Hoteles
                    </span>
                    <div className="containerTable">
                      <table>
                        <thead>
                          <tr>
                            <th>Hotel</th>
                            <th width={150}>Cantidad</th>
                            <th width={150}>Costo</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataHotels.map((item, key) => {
                            if (item.total !== 0) {
                              return (
                                <tr key={key}>
                                  <td>{item.name}</td>
                                  <td align="right">{item.count}</td>
                                  <td align="right">
                                    {numeral(item.total).format('$0,00.00')}
                                  </td>
                                </tr>
                              );
                            }
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : null}
              </Col>
            </Row>
            <Row>
              <Col md={6} sm={12}>
                <div>
                  <img
                    src={logo}
                    style={{ height: '40px', marginBottom: '10px' }}
                    alt="logo"
                  ></img>
                  <span
                    style={{
                      fontSize: '20px',
                      color: '#000',
                      fontWeight: '100',
                    }}
                  >
                    Accesos
                  </span>
                  <div className="containerTable">
                    <table>
                      <thead>
                        <tr>
                          <th style={{ textAlign: 'center' }}>Nombre</th>
                          <th style={{ textAlign: 'center' }}>Último Acceso</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.report
                          ? this.state.report.accessUsers
                            ? this.state.report.accessUsers.map(
                                function (report, index) {
                                  return (
                                    <tr key={index}>
                                      <td align="left">
                                        {report.name
                                          ? report.name
                                            ? report.name + ' '
                                            : ''
                                          : null}
                                        {report.lastName
                                          ? report.lastName
                                            ? report.lastName.charAt(0) + '.'
                                            : ''
                                          : null}
                                      </td>

                                      <td align="left">
                                        {report.lastAccess
                                          ? moment(report.lastAccess).format(
                                              'll',
                                            )
                                          : 'Sin Acceso'}
                                      </td>
                                    </tr>
                                  );
                                },
                              )
                            : null
                          : null}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
          </Grid>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    FranchiseReports: state.FranchiseReports,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(FranchiseReportsActions, dispatch);
};

const FranchiseReportsConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FranchiseReportsIndex);

export default FranchiseReportsConnect;



// WEBPACK FOOTER //
// ./src/views/FranchiseReports/FranchiseReportsIndex.jsx